import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useContext } from 'react';
import { OverlayContainer } from 'react-aria';
import { TooltipContext, TooltipTriggerStateContext } from 'react-aria-components';
import { useTooltipTriggerState } from 'react-stately';
import TooltipInner from './tooltip-inner.esm.js';
import { useContextProps, useExitAnimation } from '../../utils/index.esm.js';

var _excluded = ["UNSTABLE_portalContainer"];
function Tooltip(_ref, ref) {
  var UNSTABLE_portalContainer = _ref.UNSTABLE_portalContainer,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContextProps = useContextProps(props, ref, TooltipContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var contextState = useContext(TooltipTriggerStateContext);
  var localState = useTooltipTriggerState(props);
  var state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
  var isExiting = useExitAnimation(ref, state.isOpen) || props.isExiting || false;
  if (!state.isOpen && !isExiting) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    portalContainer: UNSTABLE_portalContainer
  }, /*#__PURE__*/React__default.createElement(TooltipInner, _extends({}, props, {
    tooltipRef: ref,
    isExiting: isExiting
  })));
}

/**
 * A tooltip displays a description of an element on hover or focus.
 */
var _Tooltip = /*#__PURE__*/forwardRef(Tooltip);
var AriaTooltip = _Tooltip;

export { AriaTooltip as default };
//# sourceMappingURL=tooltip.esm.js.map
